import { cn } from "cn";

export const AnimateDotBounce = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        /* sorted */
        "flex items-center gap-0.5",
        "min-h-4",
        className,
      )}
    >
      <div className="size-1 rounded-full bg-bg-dark-high animate-bounce-strong"></div>
      <div className="size-1 rounded-full bg-bg-dark-high animate-bounce-strong [animation-delay:-.15s]"></div>
      <div className="size-1 rounded-full bg-bg-dark-high animate-bounce-strong [animation-delay:-.3s]"></div>
    </div>
  );
};
